module.exports = __webpack_public_path__ + "fonts/Satoshi-Bold.274e274.woff2";